module.exports = __webpack_public_path__ + "static/media/pin.29aabb48.svg";